import { Box, Table, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { AccountAvatar } from "../../components/AccountAvatar";
import { Loader } from "../../components/Loader";
import { LoadMore } from "../../components/LoadMore";
import { Title } from "../../components/Title";
import { ClientProfile, useMyContactsQuery } from "../../graphql";
import { useMyContactList } from "../../hooks/useMyContactList";
import { formatDateTime } from "../../utils";
import { MyContactListFilter } from "../Call/filter";

const Patients: React.FC = () => {
    const { t } = useTranslation();
    const { items, loadMore, loading, refresh, hasNextPage } = useMyContactList();

    return (
        <>
            <>
                <Box
                    borderWidth="1px"
                    borderRadius="lg"
                    overflow="hidden"
                    p={ 2 }
                    background="white"
                >
                    <Title title={ t("patients.title") }>
                        <MyContactListFilter
                            onChange={ (query) => {
                                refresh(query);
                            } }
                        />
                    </Title>
                    { loading ? (
                        <Loader />
                    ) : (
                        <Table variant="striped" size="sm">
                            <Thead>
                                <Tr>
                                    <Th>{ t("patients.name") }</Th>
                                    <Th>{ t("patients.email") }</Th>
                                    <Th>{ t("patients.phone") }</Th>
                                    <Th>{ t("patients.tier") }</Th>
                                    <Th>{ t("patients.startDate") }</Th>
                                    <Th>{ t("patients.expirationDate") }</Th>
                                    <Th isNumeric>{ t("patients.registrationDate") }</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                { items?.map((account) => (
                                    <Tr key={ account.id }>
                                        <Td>
                                            <Link to={ `/account/${account.id}` }>
                                                <AccountAvatar
                                                    account={ account }
                                                    role={ false }
                                                    size="xs"
                                                />
                                            </Link>
                                        </Td>
                                        <Td>{ account.email }</Td>
                                        <Td>{ account.phoneNumber }</Td>
                                        <Td>
                                            { (account.profile as ClientProfile)?.subscription?.tier
                        ?.name
                                                ? (account.profile as ClientProfile)?.subscription?.tier
                            ?.name
                                                : t("patients.none") }
                                        </Td>
                                        <Td>
                                            {
                        (account.profile as ClientProfile)?.subscription
                          ?.startDate
                                            }
                                        </Td>
                                        <Td>
                                            {
                        (account.profile as ClientProfile)?.subscription
                          ?.expirationDate
                                            }
                                        </Td>
                                        <Td isNumeric>{ formatDateTime(account.createdAt) }</Td>
                                    </Tr>
                                )) }
                            </Tbody>
                        </Table>
                    ) }

                    <LoadMore hasNextPage={ hasNextPage } loadMore={ loadMore } />
                </Box>
            </>
        </>
    );
};

export default Patients;
